import { FunctionComponent } from 'react';
import i18n from 'i18n';
import Wrapper from 'pages/password-reset/components/Wrapper';
import { CheckCircleOutline } from '@material-ui/icons';
import { useNavigate } from 'react-router-dom';
import { Button } from '@material-ui/core';

const PasswordResetCheck: FunctionComponent = () => {
  const navigate = useNavigate();

  const onContinue = () => {
    navigate('/signin');
  };

  return (
    <Wrapper
      icon={<CheckCircleOutline />}
      title={i18n.t('pages.passwordReset.success.title')}
      subtitle={i18n.t('pages.passwordReset.success.subtitle')}
    >
      <Button
        variant="contained"
        color="primary"
        fullWidth
        onClick={() => onContinue()}
      >
        {i18n.t('pages.passwordReset.success.success')}
      </Button>
    </Wrapper>
  );
};

export default PasswordResetCheck;
